import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";

import { cn } from "../lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, "aria-label": ariaLabel, ...props }, ref) => {
    if (process.env.NODE_ENV !== "production" && !label && !ariaLabel) {
      // biome-ignore lint/suspicious/noConsole: development-time a11y warning
      console.warn("Input: inputs without a visible label must provide an aria-label");
    }
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-lg border border-input bg-card px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-150",
          className,
        )}
        aria-label={ariaLabel}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
